/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

module.exports = function(licenseId) {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetActiveLicensesByParentLicense: {
        $xmlns: 'http://dobs.pa.gov/nd/license/bpm/1.0',
        ParentLicenseID: licenseId
      }
    },
    blueprintArrays: ['GetActiveLicensesByParentLicenseResponse.ActiveLicenses.ND_License'],
    blueprint: {
      childLicenses: [
        '$..ND_License',
        {
          id: '$..ID',
          licenseNumber: '$..LicenseNumber',
          licenseStatus: '$..LicenseStatus',
          originalIssueDate: '$..OriginalIssueDate',
          AddressLine1: '$..AddressLine1'
        }
      ]
    }
  })
    .done(function(response) {
      deferred.resolve(response.childLicenses);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
